
<footer :class="classes(n())">
  <!-- 链接 -->
  <div :class="classes(n('links'))">
    <div v-for="(link, index) in links" :key="link.name" :class="classes(n('link'))">
      <div :class="classes(n('link-content'))" @click="link.action">
        <component v-if="link.icon" :is="link.icon" :class="classes(n('link-icon'))" />
        <a>{{ link.name }}</a>
      </div>
      <Divider v-if="index < links.length - 1" layout="vertical" />
    </div>
  </div>
  <!-- 描述 -->
  <div :class="classes(n('desc'))">
    <slot name="desc" v-if="$slots.desc"></slot>
    <span v-else>{{ desc }}</span>
  </div>
</footer>
